import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';
import { BasketSchema, BasketTypeProps } from '../types/basketSchema';

import { fetchUpdateProductInBasket } from '../services/fetchUpdateProductInBasket';
import { fetchDeleteProductFromBasket } from '../services/fetchDeleteProductFromBasket';

const initialState: BasketSchema = {
  data: {
    basket: {
      items: [],
      totalItems: 0,
      totalSpecSum: 0,
      totalSum: 0,
    },
    isLoading: true,
    showLinkBack: false,
  },
};

export const basketSlice = createSlice({
  name: 'basket',
  initialState,
  reducers: {
    setInitBasket: (state, action: PayloadAction<BasketTypeProps>) => {
      state.data.basket = action.payload;
      state.data.isLoading = false;
    },
    setShowLink: (state, action: PayloadAction<boolean>) => {
      state.data.showLinkBack = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.basket,
      };
    });
    builder
      .addCase(fetchUpdateProductInBasket.pending, state => {
        state.data.isLoading = true;
      })
      .addCase(fetchUpdateProductInBasket.fulfilled, (state, action) => {
        if (action.payload) {
          state.data.basket = action.payload;
        }
        state.data.isLoading = false;
      });
    builder
      .addCase(fetchDeleteProductFromBasket.pending, state => {
        state.data.isLoading = true;
      })
      .addCase(fetchDeleteProductFromBasket.fulfilled, (state, action) => {
        if (action.payload) {
          state.data.basket = action.payload;
        }
        state.data.isLoading = false;
      });
  },
});

export const { actions: actionBasket } = basketSlice;
